export default "__VITE_ASSET__AbyHt5J$__"